import { GridColDef } from "@mui/x-data-grid";
import { GridActionsCellItem, GridRowParams } from "@mui/x-data-grid-pro";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { ConditionalMapping } from "../../types/brochure";

export const getColumns = (
  handleEditClick: (row: GridRowParams<ConditionalMapping>) => void,
  handleDeleteClick: (row: GridRowParams<ConditionalMapping>) => void,
): GridColDef[] => {
  return [
    { field: "name", headerName: "Name", flex: 1, minWidth: 80, sortable: false },
    { field: "type", headerName: "Input", flex: 1, minWidth: 80, sortable: false },
    {
      field: "actions",
      type: "actions",
      getActions: params => [
        <GridActionsCellItem
          key={`${params.id}-edit`}
          icon={<EditIcon />}
          label="Edit"
          onClick={() => handleEditClick(params)}
        />,
        <GridActionsCellItem
          key={`${params.id}-delete`}
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => handleDeleteClick(params)}
        />,
      ],
    },
  ];
};
